export const config = {
    api : 'https://vkt-profile-backend.vercel.app'
}
